/**
 * Part del State necessari per el AdrWidget
 * Component: AdrWidgetState.ts
 * Llenguatge: TypeScript
 * Autors: Xavier Naval
 * Versió: 1.0
 * Data: 29/09/2017
 * (c) Ajuntament de Manresa - set 2017 - Departament de Sistemes d'Informació
 */
import { observable, action, computed } from 'mobx';
import AdrWidgetAPI from '../api/AdrWidgetAPI';
import { IPropsAdrWidget } from '../interfaces/IPropsAdrWidget';
import { INumero } from '../interfaces/IAdr';

export default class AdrWidgetState {
    // Constructor si no li passem cap AdrWidgetAPI en construeix un per defecte
    constructor(adrWidgetAPI?: AdrWidgetAPI, numCod?: number) {
        this.adrAPI = adrWidgetAPI || new AdrWidgetAPI();
        if (numCod) {
            this.setNumeroByNumCod(numCod);
        } else {
            this.dataNumero = [];
            this.selNumero = undefined;
        }
    }

    // L'API de l'AdrWidget
    protected adrAPI: AdrWidgetAPI;

    // Llista de Numeros
    @observable dataNumero: Array<INumero> = [];

    // El Numero seleccionat
    @observable selNumero?: INumero;

    // Retorna el NumCod actual
    @computed get NumCod(): number {
        if (this.selNumero) {
            return this.selNumero.NUMCOD;
        }
        return 0;
    }

    // Assignem el Numero (normalment ve de la selecció del desplegable)
    @action setNumero(numero?: INumero) {
        if (numero) {
            this.dataNumero = [numero];
        } else {
            this.dataNumero = [];
        }
        this.selNumero = numero;
    }

    // Llegim l'adreça' per el NumCod
    @action setNumeroByNumCod(numCod: number) {
        if (!numCod) {
            this.setNumero();
            return;
        }
        this.setNumero(this.dataNumero.find(item => item.NUMCOD === numCod));
        if (!this.selNumero) {
            this.adrAPI.getNumeroPerNumCod(numCod).then(action((result: INumero) => {
                if (result && result.NUMCOD) {
                    this.setNumero({
                        NUMCOD: result.NUMCOD,
                        ADRECA: result.ADRECA,
                        RN_: result.RN_
                    });
                } else {
                    this.setNumero();
                }
            })).catch(() => {});
        }
    }

    // Posem el input de GENERIC (Per llegir els codis per l'autocomplete d'adreces)
    @action setInputADR = (generic: string, props: IPropsAdrWidget) => {
        // Omplir el autocomplete
        if (generic && generic.length >= (props.minLength || 0) ) {
            this.adrAPI.getNumeroPerAdreca(generic, 0, (props.pageSize || 0)).then(action((result: Array<INumero>) => {
                if (result) {
                    this.dataNumero = result.map(item => { return {
                        NUMCOD: item.NUMCOD,
                        ADRECA: item.ADRECA,
                        RN_: item.RN_
                    }});
                } else {
                    this.dataNumero = [];
                }
            })).catch((reason: any) => { }); // Si hi ha un error de xarxa, l'ignorem. De vegades és pq s'escriu massa ràpid
        } else {
            this.dataNumero = [];
        }
    }

}